import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { setAppNameAction } from 'root-redux/actions/common'

import { AppName } from 'root-constants'

const APP_NAMES = {
  luvly: AppName.LUVLY,
  dancebit: AppName.DANCEBIT,
  'dance-bit': AppName.DANCEBIT,
  fasting: AppName.NUTRIMATE,
  nutrimate: AppName.NUTRIMATE,
  nutriwalk: AppName.NUTRI_WALKING,
  famio: AppName.FAMIO,
  myfamio: AppName.FAMIO,
  upluv: AppName.UPLUV,
  woofz: AppName.WOOFZ,
  meowz: AppName.MEOWZ,
  cardimate: AppName.CARDIMATE,
  fitme: AppName.FITME,
  stylio: AppName.STYLIO,
  mygrowth: AppName.MYGROWTH,
  hellopiano: AppName.HELLO_PIANO,
  ayahpath: AppName.AYAHPATH,
  karmapath: AppName.KARMAPATH,
  testora: AppName.TESTORA,
  blessedpath: AppName.BLESSEDPATH,
  spilio: AppName.SPILIO,
  deeply: AppName.DEEPLY,
  agevia: AppName.AGEVIA,
  localhost: AppName.TESTORA,
}

export const useAppNameFromUrl = (): void => {
  const dispatch = useDispatch()

  useEffect(() => {
    const sourceUrl = window.location.origin

    const appNameFromUrl =
      Object.keys(APP_NAMES).find((domain) => sourceUrl.includes(domain)) || ''

    dispatch(setAppNameAction(APP_NAMES[appNameFromUrl]) || APP_NAMES.luvly)
  }, [dispatch])
}
